import { render, staticRenderFns } from "./LimsSampleStats.vue?vue&type=template&id=0f7fdeb9"
import script from "./LimsSampleStats.vue?vue&type=script&lang=js"
export * from "./LimsSampleStats.vue?vue&type=script&lang=js"
import style0 from "./LimsSampleStats.vue?vue&type=style&index=0&id=0f7fdeb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports